import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-[#070F17] text-gray-400 py-12 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row justify-between items-center">
        
        <div className="mb-6 md:mb-0 text-center md:text-left">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/d334477e75b4fabb65d5be5423d2041faad258e6d76e6691f8155cb326e304c728474a3a46f4e57b3b2d456fd1aa0681/images/aW1hZ2UvcG5n/78bb09dd5eee04f99536674bb2e1fd61.png" 
            alt="Page1News Logo" 
            className="h-12 w-auto object-contain mx-auto md:mx-0 mb-2"
          />
        </div>

        <div className="flex space-x-6 mb-6 md:mb-0">
          <a 
            href="https://www.instagram.com/page1news?igsh=MXI4YnBqYWp4cmNsZg%3D%3D&utm_source=qr" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-gold-500 transition-colors"
          >
            <SafeIcon icon={FiIcons.FiInstagram} className="text-xl" />
          </a>
          <a href="#" className="hover:text-gold-500 transition-colors">
            <SafeIcon icon={FiIcons.FiLinkedin} className="text-xl" />
          </a>
          <a href="#" className="hover:text-gold-500 transition-colors">
            <SafeIcon icon={FiIcons.FiTwitter} className="text-xl" />
          </a>
        </div>

        <div className="text-sm text-center md:text-right">
          <p>&copy; {new Date().getFullYear()} Page1News.</p>
          <p>All narratives reserved.</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;